module.exports = __webpack_public_path__ + "static/media/2_edited.b71cfeac.jpg";